import axiosInstance from "auth/FetchInterceptor";
import {
  COMMON_API,
  PRACTIVE_MAMAGEMENT_API
} from "constants/ApiConstant";
const practiveManagementService = {};

practiveManagementService.dSNhanVien = function (data) {
  return axiosInstance.post(`${PRACTIVE_MAMAGEMENT_API}/search`, data);
};

practiveManagementService.insertKeHoachThucHanh = function (data) {
  return axiosInstance.post(`${PRACTIVE_MAMAGEMENT_API}`, data);
};

practiveManagementService.getThongTinNhanVienThucHanh = function (data) {
  return axiosInstance.post(`${PRACTIVE_MAMAGEMENT_API}/chitiet`,data);
};

practiveManagementService.getThongTinNguoiPhuTrach = function (id) {
  return axiosInstance.get(`${PRACTIVE_MAMAGEMENT_API}?id=${id}`);
};

practiveManagementService.getThongTinPhieuKeHoachThucHanh = function (id) {
  return axiosInstance.get(`${PRACTIVE_MAMAGEMENT_API}/kehoach?id=${id}`);
};

practiveManagementService.insertGiayToKemTheoThucHanh = function (data) {
  return axiosInstance.post(`${PRACTIVE_MAMAGEMENT_API}/giay-to`,data);
};

practiveManagementService.getDanhSachphieuKeHoachThucHanh = function (data) {
  return axiosInstance.post(`${PRACTIVE_MAMAGEMENT_API}/phieu`,data);
};

practiveManagementService.deleteFileGIayTokemTheo = function (id) {
  return axiosInstance.delete(`${PRACTIVE_MAMAGEMENT_API}/giay-to-kem-theo?id=${id}`);
};

practiveManagementService.getAllFileGiayToKemTheoByThucHanhId = function (id) {
  return axiosInstance.get(`${PRACTIVE_MAMAGEMENT_API}/giay-to-kem-theo?id=${id}`);
};

practiveManagementService.deletePhieu = function (id) {
  return axiosInstance.delete(`${PRACTIVE_MAMAGEMENT_API}/phieu?id=${id}`);
};


practiveManagementService.updateKetQuaThucHanh = function (data) {
  return axiosInstance.put(`${PRACTIVE_MAMAGEMENT_API}/danh-gia-thuc-hanh`,data);
};

practiveManagementService.inPhanCongThucHanh = function (data) {
  return axiosInstance.post(`${COMMON_API}/in_phan_cong`,data, {
    baseURL: process.env.REACT_APP_COMMON_ENDPOINT_URL,
  });
};

practiveManagementService.inDanhGiaThucHanh = function (data) {
  return axiosInstance.post(`${COMMON_API}/in_danh_gia`,data, {
    baseURL: process.env.REACT_APP_COMMON_ENDPOINT_URL,
  });
};

practiveManagementService.danhSachTiepNhanThucHanhPrint = function (id) {
  return axiosInstance.get(`${PRACTIVE_MAMAGEMENT_API}/danh-sach_tiep-nhan-thuc-hanh-print?id=${id}`);
};

practiveManagementService.updateDanhSachTiepNhanThucHanhPrint = function (data) {
  return axiosInstance.put(`${PRACTIVE_MAMAGEMENT_API}/danh-sach_tiep-nhan-thuc-hanh-print`,data);
};

practiveManagementService.updateDanhGiaThucHanhPrint = function (data) {
  return axiosInstance.put(`${PRACTIVE_MAMAGEMENT_API}/danh-sach_danh-gia-thuc-hanh-print`,data);
};

practiveManagementService.getDanhSachTiepNhanThucHanhPrint = function (id) {
  return axiosInstance.get(`${PRACTIVE_MAMAGEMENT_API}/hop-dong-thuc-hanh-print?id=${id}`);
};

practiveManagementService.deleteChiTietTiepNhanThucHanhById = function (id) {
  return axiosInstance.delete(`${PRACTIVE_MAMAGEMENT_API}/tiep-nhan_thuc-hanh?id=${id}`);
};

practiveManagementService.getDataDanhGiaThucHanhById = function (id) {
  return axiosInstance.get(`${PRACTIVE_MAMAGEMENT_API}/danh-gia-thuc-hanh-print?id=${id}`);
};

practiveManagementService.getAllKhoaPhongKhamTapDoan = function () {
  return axiosInstance.get(`${PRACTIVE_MAMAGEMENT_API}/phong-kham-tap-doan`);
};

practiveManagementService.getAllPhongKhamBenhVienTapDoan = function () {
  return axiosInstance.get(`${PRACTIVE_MAMAGEMENT_API}/phong-kham_bv-tap-doan`);
};

practiveManagementService.putHoanThanhThucHanh = function (data) {
  return axiosInstance.put(`${PRACTIVE_MAMAGEMENT_API}/hoan-thanh-thuc-hanh`,data);
};

practiveManagementService.getCheckHoanThanhThucHanh = function (id) {
  return axiosInstance.get(`${PRACTIVE_MAMAGEMENT_API}/check-hoan-thanh-thuc-hanh?id=${id}`);
};

practiveManagementService.getDataXacNhanThucHanhPrint = function (id) {
  return axiosInstance.get(`${PRACTIVE_MAMAGEMENT_API}/xac-nhan-thuc-hanh-print?id=${id}`);
};


practiveManagementService.upLoadHoaDon = function (data) {
  return axiosInstance.post(`${PRACTIVE_MAMAGEMENT_API}/hoa-don`,data);
};
practiveManagementService.deleteHoaDonById = function (id) {
  return axiosInstance.delete(`${PRACTIVE_MAMAGEMENT_API}/hoa-don?id=${id}`);
};
practiveManagementService.hoanThienHoSo = function (data) {
  return axiosInstance.post(`${PRACTIVE_MAMAGEMENT_API}/ho-so`,data);
};


export default practiveManagementService;
